import axios from 'axios'
import { useMemo } from 'react'
import { useAppSelector } from '../../presentation/hooks/store-hooks'
import {IAxiosAuthConfig, IAxiosAuthInstance} from '../../application/models/axios-instance'

export const useAxiosInstances = () => {
  const authState = useAppSelector((state) => state.auth)
  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: process.env.REACT_APP_BASE_URL
    })
  }, [])

  const axiosAuthInstance = useMemo(() => {
    const token = authState.token || localStorage.getItem('ACCESS_TOKEN')
    const instance = axios.create({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      baseURL: process.env.REACT_APP_BASE_URL
    })

    instance.interceptors.request.use((config) => {
      const currentToken = localStorage.getItem('ACCESS_TOKEN') || authState.token;
      if (currentToken) {
        config.headers.Authorization = `Bearer ${currentToken}`;
      }
      return config;
    });

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        const skipAuthRedirect = (error?.config as IAxiosAuthConfig)?.skipAuthRedirect
        if (error?.response?.status === 401 && !skipAuthRedirect) {
          localStorage.removeItem('ACCESS_TOKEN');
          localStorage.removeItem('SESSION_START_TIMESTAMP');
          const loginUrl =
            process.env.REACT_APP_VELES_LOGIN_URL ||
            (process.env.REACT_APP_VELES_MODULES_URL || '').replace('/modulos', '/authentication/login');
          window.location.replace(loginUrl);
        }
        return Promise.reject(error);
      }
    )

    return instance as IAxiosAuthInstance;
  }, [authState.token])
  return {
    axiosInstance,
    axiosAuthInstance
  }
}